




































import { AuthFactory } from "@/shared/api/auth";
import { Component, Vue, } from "@/shared/vuepack";
import { withTableauDashboards } from "@/employer/utilities/withTableauDashboards";
import MetricWithGraph from "@/employer/components/metric/MetricWithGraph.vue";
import MetricTabsWithContent from "@/employer/components/metric/MetricTabsWithContent.vue";
import { useUserStore } from "@/shared/store/user";
import { usePartnerSettingStore } from "@/shared/store/partnerSetting";

@Component({
  components: {
    MetricWithGraph,
    MetricTabsWithContent,
  },
})
export default class MyProgramMetrics extends Vue {
  userStore = useUserStore();
  partnerSettingStore = usePartnerSettingStore();
  accessToken = AuthFactory.getAuth().accessToken();
  programHealthMetrics: any[] = [];
  programSnapshotMetrics: any[] = [];

  programHealthSelectors = [
    "HSA-ProgramHealth",
    "HRA-ProgramHealth",
    "HRARRA-ProgramHealth",
    "HRALSA-ProgramHealth",
    "HRAWellness-ProgramHealth",
    "FSAHC-ProgramHealth",
    "FSADC-ProgramHealth",
    "FSALP-ProgramHealth",
    "Parking-ProgramHealth",
    "Transit-ProgramHealth"
  ];
  programSnapshotSelectors = ["HSA-ProgramSnapshot", "FSA-ProgramSnapshot", "Commuter-ProgramSnapshot", "HRA-ProgramSnapshot"];

  async created () {
    this.programHealthMetrics = await this.userStore.getMetricsWithGraphs(this.programHealthSelectors);
    this.programSnapshotMetrics = await this.userStore.getMetricsWithContent(this.programSnapshotSelectors);
  }

  get hasOptimize (): boolean {
    return this.partnerSettingStore.settings.resourceOptimizationEnabled;
  }

  mounted () {
    this.partnerSettingStore.loadEmployerPartnerSettings({
      partnerId: this.userStore.currentEmployer.partnerId,
      employerId: this.userStore.currentEmployer.employerId
    });
    withTableauDashboards();
  }

  get employerCode (): string {
    return this.userStore.currentEmployer.wexEmployerCode;
  }
}
